import React from "react";

export const DoneIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      {...props}
    >
      <path d="M1 3L7.5 10L17 0.499999" />
    </svg>
  );
};
